<template>
    <div
        class="z-contact-card"
        :class="classObject">
        <z-contact-person
            v-if="data.title"
            :size="size"
            :name="data.title"
            :description="data.previewText"
            :image="data.previewPicture"
            :hide-image="hideImage"
        />

        <div class="z-contact-card__list">
            <div
                class="z-contact-card__item z-phone"
                v-if="data.phones?.length">
                <template
                    v-for="(item, index) in data.phones"
                    :key="`phone-${index}`">
                    <div class="z-contact-card__row">
                        <div class="z-contact-card__title">
                            <z-icon
                                v-if="index === 0 && showIcons"
                                name="contacts/phone"
                            />
                            <span v-if="index === 0 && showCaptions">{{ text.phone }}</span>
                        </div>
                        <z-link
                            class="z-contact-card__link"
                            :href="`tel:${item.value}`"
                            theme="dark"
                            :size="size"
                            :underlined="false">
                            {{ item.text || item.value }}
                        </z-link>
                    </div>
                </template>
            </div>

            <div
                class="z-contact-card__item"
                v-if="data.emails?.length">
                <template
                    v-for="(item, index) in data.emails"
                    :key="`email-${index}`">
                    <div class="z-contact-card__row">
                        <div class="z-contact-card__title">
                            <z-icon
                                v-if="index === 0 && showIcons"
                                name="contacts/at"
                            />
                            <span v-if="index === 0 && showCaptions">{{ text.email }}</span>
                        </div>
                        <z-link
                            class="z-contact-card__link"
                            theme="dark"
                            :href="`mailto:${item.value}`"
                            :size="size"
                            :underlined="false">
                            {{ item.text || item.value }}
                        </z-link>
                    </div>
                </template>
            </div>

            <div
                class="z-contact-card__item"
                v-if="data.faxes?.length">
                <template
                    v-for="(item, index) in data.faxes"
                    :key="`fax-${index}`">
                    <div class="z-contact-card__row">
                        <div class="z-contact-card__title">
                            <z-icon
                                v-if="index === 0 && showIcons"
                                name="contacts/fax"
                            />
                            <span v-if="index === 0 && showCaptions">{{ text.fax }}</span>
                        </div>
                        <z-link
                            class="z-contact-card__link"
                            :href="`fax:${item.value}`"
                            theme="dark"
                            :size="size"
                            :underlined="false">
                            {{ item.text || item.value }}
                        </z-link>
                    </div>
                </template>
            </div>

            <div
                class="z-contact-card__item"
                v-if="data.address">
                <div class="z-contact-card__row">
                    <div class="z-contact-card__title">
                        <z-icon
                            v-if="showIcons"
                            name="contacts/map"
                        />
                        <span v-if="showCaptions">{{ text.address }}</span>
                    </div>
                    <span v-html="data.address"></span>
                </div>
            </div>

            <div
                class="z-contact-card__item"
                v-if="data.sites?.length">
                <template
                    v-for="(item, index) in data.sites"
                    :key="`site-${index}`">
                    <div class="z-contact-card__row">
                        <div class="z-contact-card__title">
                            <z-icon
                                v-if="index === 0 && showIcons"
                                name="contacts/desktop"
                            />
                            <span v-if="index === 0 && showCaptions">{{ text.site }}</span>
                        </div>
                        <z-link
                            class="z-contact-card__link"
                            :href="item.value"
                            :size="size"
                            :underlined="false"
                            target="_blank">
                            {{ item.description || item.value }}
                        </z-link>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import {localize} from '@/utils/i18n'

const props = defineProps({
    data: {
        type: Object
    },
    hideImage: {
        type: Boolean,
    },
    size: {
        type: String,
        default: 's'
    },
    horizontal: {
        type: Boolean,
        default: false
    },
    showIcons: {
        type: Boolean,
        default: false
    },
    showCaptions: {
        type: Boolean,
        default: true
    },
    isValueDirColumn: {
        type: Boolean,
        default: false
    }
})

const text = {
    phone: localize({
        ru: 'Телефон:',
        en: 'Phone:',
        cn: '电话：'
    }),
    fax: localize({
        ru: 'Факс:',
        en: 'Fax:',
        cn: 'Fax:'
    }),
    email: localize({
        ru: 'E-mail:',
        en: 'E-mail:',
        cn: '电子邮件：'
    }),
    site: localize({
        ru: 'Сайт',
        en: 'Website:',
        cn: 'Website:'
    }),
    address: localize({
        ru: 'Адрес',
        en: 'Address:',
        cn: '地址：'
    })
}

const classObject = computed(() => ({
    'z-contact-card--horizontal': props.horizontal,
    'z-contact-card--dir-column': props.isValueDirColumn
}))
</script>

<style lang="scss" src="./index.scss"></style>
